var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-comment__container",staticStyle:{"padding":"0 .2rem"}},_vm._l((3),function(i){return _c('s-comment-item',{key:i,staticClass:"van-hairline--bottom"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }